import type JSZip from "jszip";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
let jsZipModule: any;

async function getJSZipModule() {
    if (jsZipModule) {
        return jsZipModule;
    }

    jsZipModule = (await import(/* webpackChunkName: "jszip", webpackPrefetch: true */"jszip")).default;
    return jsZipModule;
}

async function createNewZip(): Promise<JSZip> {
    const JSZipModule = await getJSZipModule();
    return new JSZipModule();
}

export {
    createNewZip
};
